import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-manager.png'
import _imports_1 from '@/assets/images/favorite-chart.png'
import _imports_2 from '@/assets/images/status-up.png'
import _imports_3 from '@/assets/images/setting.png'
import _imports_4 from '@/assets/images/taskcenter.png'


const _hoisted_1 = {
  class: "custom-navi",
  style: {"padding-bottom":"70px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "navi-icon",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "navi-icon",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "navi-icon",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "navi-icon",
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "navi-icon",
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "navi-icon",
  src: _imports_4,
  alt: ""
}, null, -1)

import { defineComponent, reactive, toRefs, watch, ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import {  
  UserStatusMap,
  UserRoleOperator,
  UserRoleDirectorManager,
  UserRoleDirector,
  UserRoleBlogger,
  UserRoleAuditor,
} from '@/utils/macro'



export default /*#__PURE__*/_defineComponent({
  __name: 'Navi',
  setup(__props) {

const isProd = ref(window.location.hostname=='koc.marsvis.com')

const store = useStore()

const user_role = computed(() => store.state.user.role)

const router = useRouter()
const route = useRoute()

console.log('route.meta.key', route.meta.key);

const openKeys = ref([])
const selectedKeys = ref([])

onMounted(() => {
  selectedKeys.value = [route.path]
  console.log('route', route);
  
  openKeys.value = [route.meta.key]
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_menu, {
      openKeys: openKeys.value,
      "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((openKeys).value = $event)),
      selectedKeys: selectedKeys.value,
      "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
      mode: "inline"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_sub_menu, { key: "basic" }, {
          icon: _withCtx(() => [
            _hoisted_2
          ]),
          title: _withCtx(() => [
            _createTextVNode("用户管理")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "/keywords/profile" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/profile'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 个人设置 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/bloggers" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/bloggers'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 博主管理 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            ([ _unref(UserRoleDirectorManager) ].indexOf(user_role.value) > -1)
              ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/keywords/directors" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { path: '/keywords/directors'} }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 团长管理 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_sub_menu, { key: "keyword" }, {
          icon: _withCtx(() => [
            _hoisted_3
          ]),
          title: _withCtx(() => [
            _createTextVNode("推广中心")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeAccounts" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeAccounts'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 账号管理 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeMaterials" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeMaterials'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 素材管理 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeWorks" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeWorks'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 作品管理 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeCredentials" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeCredentials'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 凭证管理 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/apply" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/apply'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 关键词管理 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_sub_menu, { key: "stats" }, {
          icon: _withCtx(() => [
            _hoisted_4
          ]),
          title: _withCtx(() => [
            _createTextVNode("数据中心")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "/keywords/stats_keyword" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/stats_keyword'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 关键词每日数据 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/stats_keyword_sum" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/stats_keyword_sum'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 关键词累计数据 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/stats_data_blogger" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/stats_data_blogger'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 博主累计数据 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/stats_newer_platform_sum" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/stats_newer_platform_sum'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 平台累计数据 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            ([ _unref(UserRoleDirectorManager) ].indexOf(user_role.value) > -1)
              ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/keywords/stats_data_director_daily" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { path: '/keywords/stats_data_director_daily'} }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 团长每日统计 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ([ _unref(UserRoleDirectorManager) ].indexOf(user_role.value) > -1)
              ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/keywords/stats_data_director" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { path: '/keywords/stats_data_director'} }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 团长数据统计 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_menu_item, { key: "/keywords/settlement" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/settlement'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 结算数据 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/activity" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/activity'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 活动数据报表 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeWorkDatas" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeWorkDatas'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" CPE作品数据 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        ([ _unref(UserRoleDirectorManager) ].indexOf(user_role.value) > -1)
          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "payment" }, {
              icon: _withCtx(() => [
                _hoisted_5
              ]),
              title: _withCtx(() => [
                _createTextVNode("付款管理")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, { key: "/keywords/payment_signs" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { path: '/keywords/payment_signs'} }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 用户签约状态 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_sub_menu, { key: "setting" }, {
          icon: _withCtx(() => [
            _hoisted_6
          ]),
          title: _withCtx(() => [
            _createTextVNode("设置")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "/keywords/upload" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/upload'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 上传管理 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_menu_item, { key: "/keywords/taskcenter" }, {
          icon: _withCtx(() => [
            _hoisted_7
          ]),
          title: _withCtx(() => [
            _createTextVNode("任务中心")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: { path: '/keywords/taskcenter'} }, {
              default: _withCtx(() => [
                _createTextVNode(" 任务中心 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["openKeys", "selectedKeys"])
  ]))
}
}

})